import React from 'react';
import PlayerLoginForm from '../components/PlayerLoginForm';
import { Link } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';

const PlayerLoginPage = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 10, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Player Portal Login
        </Typography>

        <PlayerLoginForm />

        <Typography variant="body2" sx={{ mt: 2 }}>
          Don't have an account?{' '}
          <Link to="/player/signup" style={{ textDecoration: 'none', color: '#1976d2' }}>
            Sign up here
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default PlayerLoginPage;
